export {
  DeckSubcategoryTag,
  DeckSubcategoryTagProps,
} from './DeckSubcategoryTag';
